import React from 'react';
import { Neo, NeoGrid, Views } from '@singularsystems/neo-react';
import IDTRateVM from './IDTRateVM';
import { observer } from 'mobx-react';
import * as CatalogueRoles from "../../../Models/Security/CatalogueRoles"
import IDTRate from '../../../Models/Catalogue/Pipeline/IDTRate';
import { Misc } from '@singularsystems/neo-core';

@observer
export default class IDTRateView extends Views.ViewBase<IDTRateVM> {

    constructor(props: unknown) {
        super("IDT Rate", IDTRateVM, props);
    }

    public render() {
        return (
            <Neo.Card title="Edit IDT Rates">
                <div>
                    <div className="d-flex justify-content-between mb-4">
                        <Neo.Button icon="arrow-left" variant="light" onClick={() => history.back()}>Back</Neo.Button>
                        <Neo.Button
                            icon="save"
                            pulse={this.viewModel.pageManager.data.isDirty}
                            disabled={!this.viewModel.pageManager.data.isDirty}
                            isSubmit form="idt-rates-form">
                            Save
                        </Neo.Button>
                    </div>
                    <Neo.Card title="Filter">
                        <div className="row">
                            <Neo.FormGroupInline bind={this.viewModel.criteria.meta.startDate} editorTooltip='If no date is selected, all results will be displayed.' className="col-lg-3" />
                            <Neo.FormGroupInline bind={this.viewModel.criteria.meta.endDate} editorTooltip='If no date is selected, all results will be displayed.' className="col-lg-3" />
                        </div>
                    </Neo.Card>
                    <Neo.Form id="idt-rates-form" model={this.viewModel.pageManager.data} showSummaryModal onSubmit={() => this.viewModel.saveIDTRates()} allReadOnly={!this.viewModel.authorisationService.hasRole(CatalogueRoles.IDTRates.Edit)}>
                        <Neo.Card title={"IDT Rates"}>
                            <Neo.Pager pageManager={this.viewModel.pageManager} pageControls="bottom" >
                                <NeoGrid.Grid<IDTRate> showAddButton>
                                    {(item, meta) => (
                                        <NeoGrid.Row>
                                            <NeoGrid.Column bind={meta.rateDate} />
                                            <NeoGrid.Column bind={meta.idtr}
                                                numProps={{ format: Misc.NumberFormat.PercentDecimals }}
                                                alignment="center" />
                                            <NeoGrid.ButtonColumn showDelete />
                                        </NeoGrid.Row>
                                    )}
                                </NeoGrid.Grid>
                            </Neo.Pager>
                        </Neo.Card>
                    </Neo.Form>
                </div>
            </Neo.Card>
        );
    }
}